import {
  jb_article_page_hero_css_default
} from "./chunk.EKR2UPIZ.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-article-page-hero/jb-article-page-hero.ts
var JbArticlePageHero = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return {
      grid: true,
      colsMdUp: "none",
      horizontal: "full-width",
      type: "text"
    };
  }
  _hasAllToolBarProperties() {
    return this.toolBarButtons?.length > 0 && this.toolBarMailSubject !== void 0 && this.toolBarShareBarLabel !== void 0 && this.toolBarShareServices?.length > 0 && this.toolBarUrl !== void 0;
  }
  render() {
    return b`
      <article>
        <header>
          ${this.headline ? b`<jb-heading
                  rank="1"
                  variant="title"
                  >${this.headline}</jb-heading
                >` : A}
          <div>
            <span>${this.date} ${this.author}</span>
            <span><jb-icon iconName="material:timer"></jb-icon>${this.readingTime}</span>
          </div>
        </header>

        ${this.breadcrumbs ? b`
                <jb-breadcrumbs .ariaLabels=${this.breadcrumbs.ariaLabels ?? A}>
                  ${this.breadcrumbs.backlink && b`<jb-breadcrumbs-back-link
                      .link=${this.breadcrumbs.backlink.link}
                      .text=${this.breadcrumbs.backlink.text}
                      slot="backlink"
                    ></jb-breadcrumbs-back-link>`}
                  ${this.breadcrumbs.items?.map(
      (breadcrumb) => b`<jb-breadcrumbs-item
                        .link=${breadcrumb.link}
                        .text=${breadcrumb.text}
                        slot="items"
                      ></jb-breadcrumbs-item>`
    )}
                </jb-breadcrumbs>
              ` : A}

        <figure>
          <jb-picture
            .alt=${this.image.picture.alt}
            .imgData=${this.image.picture.imgData}
            .lazy=${this.image.picture.lazy}
          ></jb-picture>
          <figcaption>
            <div class="caption-wrapper">
              ${this.image.caption ? b`<p class="caption">${this.image.caption}</p>` : A}
              ${this.image.text ? b`<p class="text">${this.image.text}</p>` : A}
              ${this.image.credit ? b`<p class="credit">${this.image.credit}</p>` : A}
            </div>
          </figcaption>
        </figure>

        ${this.text ? b`<p class="intro-text">${this.text}</p>` : A}
        ${this._hasAllToolBarProperties() ? b`
                <jb-article-tool-bar
                  .articleTitle=${this.headline}
                  .buttons=${this.toolBarButtons}
                  .mailSubject=${this.toolBarMailSubject}
                  .title=${this.toolBarShareBarLabel}
                  .shareBarLabel=${this.toolBarShareBarLabel}
                  .shareServices=${this.toolBarShareServices}
                  .url=${this.toolBarUrl}
                ></jb-article-tool-bar>
              ` : A}
      </article>
    `;
  }
};
JbArticlePageHero.styles = [reset_css_default, jb_article_page_hero_css_default];
__decorateClass([
  n()
], JbArticlePageHero.prototype, "author", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "date", 2);
__decorateClass([
  n({ reflect: true })
], JbArticlePageHero.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "image", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "readingTime", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "text", 2);
__decorateClass([
  n({ type: Array })
], JbArticlePageHero.prototype, "toolBarButtons", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "toolBarMailSubject", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "toolBarShareBarLabel", 2);
__decorateClass([
  n({ type: Array })
], JbArticlePageHero.prototype, "toolBarShareServices", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "toolBarUrl", 2);
JbArticlePageHero = __decorateClass([
  customElement("jb-article-page-hero")
], JbArticlePageHero);

export {
  JbArticlePageHero
};
